/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from "@angular/core";
import { AreaOfWork } from "@models/areaOfWork.model";
import { CapitalNeed } from "@models/capitalNeed.model";
import { Funding } from "@models/funding.model";
import { Project } from "@models/project.model";
import { Schedule } from "@models/schedule.model";
import * as XLSX from "xlsx";

class ExtraDevelopment {
  constructor(
    public id: number,
    public name: string,
    public address: string,
    public borough: string,
    public district: string,
    public latitude: string,
    public longitude: string,
    public areasOfWork: AreaOfWork[] = [],
    public totalInvestment: number = 0,
    public developmentPicture: string = "",
  ) {
    this.totalInvestment = +parseFloat(
      areasOfWork
        .flatMap((a) =>
          a.projects
            .filter((x) => x.otherDevelopments.length <= 1)
            .flatMap((z) => z)
            .reduce((acc, current) => acc + current.projectTotalBudget, 0),
        )
        .reduce((a, b) => a + b, 0) + "",
    ).toFixed(2);
  }
}

@Component({
  selector: "app-data-generate",
  templateUrl: "./data-generate.component.html",
  styleUrls: ["./data-generate.component.scss"],
})
export class DataGenerateComponent implements OnInit {
  dataStore: any = {};
  developmentList: ExtraDevelopment[] = [];
  projectList: Project[] = [];
  scheduleList: Schedule[] = [];
  fundingList: Funding[] = [];
  capitalNeeds: CapitalNeed[] = [];

  async ngOnInit(): Promise<void> {
    // await this.loadSpreadSheet("needed/Tracker-Funding Data");
    await this.loadSpreadSheet("all data");
    this.generateFunding();

    // await this.loadSpreadSheet("needed/Tracker-Schedule Data");
    this.generateSchedule();

    // await this.loadSpreadSheet("needed/Tracker-Project List");
    this.generateProjects();
    this.generateCapitalNeeds();

    // await this.loadSpreadSheet("needed/development_representatives");

    // await this.loadSpreadSheet("needed/development_details");
    this.generateDevelopments();

    // console.log("loading big data", new Date().toLocaleTimeString());

    // console.log(" loaded big data", new Date().toLocaleTimeString());

    console.log("all data dataStore", this.dataStore);
    console.log(
      "developmentList",
      this.developmentList.find((d) => d.id == 82),
    );
    // console.log(
    //   "developmentList",
    //   this.developmentList.find((d) => d.id == 82)?.areasOfWork.filter(a=> a.name == 'Apartments'),
    // );
    console.log("projectList", this.projectList);
    console.log("capitalNeeds", this.capitalNeeds);
    console.log("scheduleList", this.scheduleList);
    console.log("fundingList", this.fundingList);
  }

  loadSpreadSheet(fileName: string): Promise<void> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const reader: FileReader = new FileReader();

      const sheet = await fetch(`/assets/data/${fileName}.xlsx`).then((res) => {
        return res.blob().then((res) => res);
      });

      const target = sheet;
      this.dataStore["filename"] = target;

      reader.onload = (e: any) => {
        const binaryString: string = e.target.result;

        const workBook: XLSX.WorkBook = XLSX.read(binaryString, {
          type: "binary",
        });

        // eslint-disable-next-line prefer-const
        for (let [i] of workBook.SheetNames.entries()) {
          const workSheetName: string = workBook.SheetNames[i];
          const workSheet: XLSX.WorkSheet = workBook.Sheets[workSheetName];
          const data = XLSX.utils.sheet_to_json(workSheet, { raw: true });

          this.dataStore[workSheetName] = data;
        }

        resolve();
      };

      reader.readAsBinaryString(target);
    });
  }

  generateFunding(): void {
    for (const funding of this.dataStore["funding"]) {
      this.fundingList.push(
        new Funding(
          funding["Project Id"],
          funding["Funding Category Description"],
          funding["Total Funds"],
          funding["Total Budget"],
        ),
      );
    }
  }

  generateSchedule(): void {
    for (const schedule of this.dataStore["scheduling"]) {
      this.scheduleList.push(
        new Schedule(
          schedule["Project Id"],
          schedule["Master Task Name"],
          schedule["Percent Complete"],
          new Date(Date.UTC(0, 0, schedule["Baseline Start Date"])).toLocaleDateString(),
          new Date(Date.UTC(0, 0, schedule["Baseline Finish Date"])).toLocaleDateString(),
          new Date(Date.UTC(0, 0, schedule["Start Date"])).toLocaleDateString(),
          new Date(Date.UTC(0, 0, schedule["Finish Date"])).toLocaleDateString(),
          new Date(Date.UTC(0, 0, schedule["Actual Start Date"])).toLocaleDateString(),
          new Date(Date.UTC(0, 0, schedule["Actual Finish Date"])).toLocaleDateString(),
        ),
      );
    }
  }

  generateProjects(): void {
    for (const project of this.dataStore["projects"]) {
      const devs: number[] = project["TDS#"].split(",").map((a: string) => parseInt(a));
      let projectName = project["Development"];

      if (devs.length > 1) {
        projectName = project["Development"].split(",")[0];
      }
      this.projectList.push(
        new Project(
          project["Project Id"],
          project["Description"],
          project["Project Status"],
          project["Project Scope of Work"],
          devs[0],
          projectName,
          project["Project Delivery Type"],
          project["Project Manager"],
          project["Project Update"],
          new Date(Date.UTC(0, 0, project["Updated Date"], -7)),
          project["Department"],
          project["Primary Work Type"],
          this.fundingList.filter((item: Funding) => item.projectId == project["Project Id"]),
          this.scheduleList.filter((item: Schedule) => item.projectId == project["Project Id"]),
          devs.filter((d) => d != devs[0]),
        ),
      );
    }
  }

  generateDevelopments(): void {
    for (const development of this.dataStore["developments"]) {
      const projects = this.projectList.filter(
        (project: Project) => project.developmentId == development["DevelopmentId"],
      );
      const areasOfWork = [...new Set(projects.map((p) => p.areaOfWork))];

      this.developmentList.push(
        new ExtraDevelopment(
          development["DevelopmentId"],
          development["Name"],
          development["Address"],
          development["Borough"],
          this.dataStore["representatives"].find(
            (devRep: any) =>
              devRep.tds == development["DevelopmentId"] && devRep.city_council_district != "",
          )?.city_council_district ?? "",
          development["Lat"],
          development["Lon"],
          areasOfWork.map((areaOfWork) => {
            return new AreaOfWork(
              areaOfWork,
              projects.filter((p) => p.areaOfWork == areaOfWork),
              this.capitalNeeds.find(
                (c) =>
                  c.developmentId == development["DevelopmentId"] && areaOfWork == c.areaOfWork,
              )?.fiveYearCapitalNeeds,
              this.capitalNeeds.find(
                (c) =>
                  c.developmentId == development["DevelopmentId"] && areaOfWork == c.areaOfWork,
              )?.twentyYearCapitalNeeds,
            );
          }),
        ),
      );
    }
  }

  /**
     PACT != Converted
    Overrides = NULL
    act_year in (2023,2024,2025,2026,2027) = 5-year needs
    act_year in (2023,2024,2025,2026,2027,2028,2029,2030,2031,2032,2033,2034,2035,2036,2037,2038,2039,2040,2041,2042) = 20-year needs
    FILTER on DEVELOPMENT
    sum(final_cost) = total costs
    primary_worktype = Area of Work
*/
  generateCapitalNeeds(): void {
    for (const data of this.dataStore["pna_data"]) {
      this.capitalNeeds.push({
        developmentId: data["DevelopmentId"],
        fiveYearCapitalNeeds: data["five_year_need"],
        twentyYearCapitalNeeds: data["twenty_year_need"],
        areaOfWork: data["primary_worktype"],
        sortOrder: 0,
      });
    }
  }
}
